'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var CalendarMonth = {};

exports.__exports = CalendarMonth;
